import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"
import type { PaymentStatus } from "@/features/payments/types"

interface PurchaseState {
  status: PaymentStatus
  paymentIntentId: string | null
  planId: string | null
  error: string | null
  setSuccess: (paymentIntentId: string, planId: string) => void
  setError: (error: string) => void
  reset: () => void
}

export const usePurchaseStore = create<PurchaseState>()(
  persist(
    (set) => ({
      status: "idle",
      paymentIntentId: null,
      planId: null,
      error: null,
      setSuccess: (paymentIntentId, planId) =>
        set({ status: "success", paymentIntentId, planId, error: null }),
      setError: (error) => set({ status: "error", error }),
      reset: () => set({ status: "idle", paymentIntentId: null, planId: null, error: null }),
    }),
    {
      name: "bp-purchase",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
